export const THEME_KEY = "lang";
